module.exports = __webpack_public_path__ + "static/media/swiper.b0c0eca8.jpg";